/** web-studio-sites D7: what open times' current state requires a drawing to show: each shown time, opening it. */
import type { RequiredParts } from '../../contract/required';
import type { OpenTimesState } from './contract';

export const requiredParts: RequiredParts<OpenTimesState> = (state) =>
  !state.selected || state.timesStatus !== 'ready'
    ? []
    : state.days.flatMap((d) => d.times.map((t) => ({ part: 'time', item: t.startsAt, action: 'openTime' })));
